import React, { useEffect, useState } from 'react'
import { API } from '../../../services/api';
import { HeaderAdmin } from "../../components/HeaderAdmin/HeaderAdmin";
import { LateralMenu } from "../../components/LateralMenu/LateralMenu";
import ImgLoading from '../../../assets/cargacaleta.gif';
import './PendingComments.scss'
import { useHistory } from 'react-router-dom';

export function PendingCommentsPage(){
  /**
   * Vista de comentarios pendientes
   * Se consulta los comentarios pendientes al servidor
   * y se los renderiza en una tabla
   */
  const [comments, setComments] = useState([]);
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const protectedRoute = ()=>{
    const sessionToken = localStorage.getItem('sessionToken');
    if(!sessionToken){
      history.push('/staff-login')
    }
  }
  
  const updateStatus = async(commentId, status, mensaje)=>{
    try {
      if(window.confirm(mensaje)){
        setLoading(true);
        /**
         * Actualizar el estado del comentario
         * se hace el llamando al servicio /comments/update-comment-status
         */
        await API.putUpdateCommentStatus(commentId,status);
        /**
         * Obtener comentarios pendientes
         * Se hace el llamado al servicio /comments/get-pending-comments
         */
        const data = await API.getPendingComments();
        setComments(data ?? [])
        setLoading(false);
      }
    } catch (error) {
      setComments([]);
      setLoading(false);
    }    
  }

  useEffect(() => {
    protectedRoute();
    setLoading(true);
    /**
     * Obtener comentarios pendientes
     * Se hace el llamado al servicio /comments/get-pending-comments
     */
    API.getPendingComments()
      .then(res => {
        setComments(res);
        setLoading(false);
      })
      .catch(err => {
        setComments([]);
        setLoading(false);
      })
  }, []);

  if(loading){
    return <>
      <HeaderAdmin />
      <LateralMenu />
      <main className='content-img'>
        <img className='img-loading' src={ImgLoading} alt="" />
      </main>
    </>
  }

  return (
    <>
      <HeaderAdmin />
      <LateralMenu />
      <main className="content">
        <h2>Comentarios Pendientes</h2>
        <div className="content-table">
          <table>
            <thead>
              <tr>
                <th>Nombres</th>
                <th>Email</th>
                <th>Comentario</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {
                comments.map((item, index) => (
                  <tr key={index}>
                    <td>{item.authorName}</td>
                    <td>{item.authorEmail}</td>
                    <td>{item.content}</td>
                    <td>
                      <a 
                        className='link-detail'
                        onClick={() => updateStatus(item._id,'APPROVED','Aprobar comentario?')}>
                        Aprobar</a>
                        <br />
                        <a 
                        className='link-detail'
                        onClick={() => updateStatus(item._id,'REJECTED','Rechazar comentario?')}>
                        Rechazar</a>
                    </td>
                  </tr>
                ))
              }
            </tbody>
          </table>
        </div>
      </main>
    </>
  );
}